<mat-dialog-content>
    <div class="confirm-dialog-wrapper">
        <h1 mat-dialog-title class="confirm-dialog-title">{{ data.title }}</h1>

        @if(data.text) {
        <p class="confirm-dialog-text">{{ data.text }} </p>
        }

        <div mat-dialog-actions class="confirm-dialog-actions">
            @if(data.cancelButton) {
            <button mat-raised-button (click)="onCancel()">{{
                data.cancelButton }}</button>
            }

            @if(data.confirmButton) {
            <button mat-raised-button color="primary" (click)="onConfirm()" cdkFocusInitial> {{
                data.confirmButton }} </button>
            }
        </div>
    </div>
</mat-dialog-content>